<template>
    <div class="problems">
        <servicesList></servicesList>
        <ul class="category_lists">
            <li v-for="(n,i) in problemsItemArr" :key="i" @click="problemCategory(i,'1')"
                :class="{ category_active:problems_index === i}">{{n}}
            </li>
        </ul>
        <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-if="isEmptyData"><img
                src='../../assets/images/no_page.png' alt='没有数据' width="160"></div>
        <div v-else>
            <problemsList v-for="(o,i) in problemsContent" :problems-content="o" :key="i"
                          :problemsIndex='i'></problemsList>
            <div v-html="pagination" class="paging_numbers" ref="pagination"></div>
        </div>

    </div>
</template>
<script>
import problemsList from "../../components/services/problemsList";
import servicesList from "../../components/services/servicesList";

export default {
  name: "problems",
  data: function() {
    return {
      problems_index: 0,
      problemsItemArr: [],
      problemsContent: [],
      isEmptyData: false,
      pagination: "",
      cat_id: ""
    };
  },
  inject: ["showMsg"],
  components: {
    problemsList,
    servicesList
  },
  created: function() {
    this.getProblem();
    this.problemCategory(0, "1");
    this.$store.commit("set_current_index", 3);
    this.$store.commit("set_current", 5);
    this.$store.commit("set_title", "nav.service");
  },
  methods: {
    getProblem() {
      this.$http({
        method: "post",
        url: this.weburl + "/home/Serve/questionList",
        dataType: "json",
        data: {
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            for (let i = 0; i < res.data.result.params.length; i++) {
              this.problemsItemArr.push(res.data.result.params[i].name);
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    problemCategory: function(i, p) {
      this.problems_index = i;
      this.cat_id = parseInt(i) + parseInt("1");
      this.$http({
        method: "post",
        url: this.weburl + "/home/Serve/questionList?p=" + p,
        dataType: "json",
        data: {
          cat_id: this.cat_id,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.isEmptyData = false;
              this.problemsContent = res.data.result.params;
              this.pagination = res.data.result.show;
              if (res.data.result.show) {
                setTimeout(() => {
                  this.GetDom();
                }, 1000);
              }
            } else {
              this.isEmptyData = true;
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    GetDom() {
      var DOM = this.$refs.pagination;
      var a_dom = DOM.getElementsByTagName("a");
      var that = this;
      for (var i = 0; i < a_dom.length; i++) {
        a_dom[i].onclick = function() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          that.problemCategory(that.cat_id, this.dataset.p);
        };
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.GetDom();
    }, 1000);
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/categoryLists";
@import "../../assets/less/direction";

.category_lists {
  margin: 10px 10px 0;
}

.problems {
  min-height: 300px;
  .media;
}
</style>
<style>
@import "../../assets/css/pagination.css";
.problems table {
  width: 100%;
}
</style>
